import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import axios from 'axios'
import { useParams, Link } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar'

import styles from '../../App.module.css'
import classes from './ChangePassword.module.css'

function ChangePassword() {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [progress, setProgress] = useState(100);
    const [isMatched, setIsMatched] = useState(false);
    const [email, setEmail] = useState('');
    const [key, setKey] = useState('');
    const [msg, setMsg] = useState({
        'status': '',
        'message': ''
      })

    useEffect(() => {
        let url = new URLSearchParams(window.location.search);
        let email = url.get("m");
        let key = url.get("k");
        
        setEmail(email);
        setKey(key);
    } , [])

    useEffect(() => {
        if(email && key) {
            axios.post(`${process.env.REACT_APP_API_URL}/api/changepassword.php`, {
                email: email,
                key: key,
                action: 'CHECK_USER'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(res => {
                console.log(res.data);

                if(res.data.status === 'success') {
                    setIsMatched(true);
                }
            }).catch(err => {
                console.log(err);
            })
        }
    }, [email, key])

    const onSubmit = (e) => {
        const data = new FormData();
        data.append('email', email);
        data.append('key', key);
        data.append('action', 'CHANGE_PASSWORD');
        data.append('password', e.password);
        data.append('confirm_password', e.confirm_password);

        axios.post(`${process.env.REACT_APP_API_URL}/api/changepassword.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                console.log(res.data);

                setMsg({
                    status: res.data.status,
                    message: res.data.message
                })
            }).catch(err => {
                console.log(err);
            })
    }

    return (
        <>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <div className={classes.main_body}>
                <div className={classes.main_content}>
                    <div className={classes.box_wrapper}>
                    { msg.status !== '' && msg.message !== '' && <div className={`alert alert-${msg.status} mb-5`} role="alert">{msg.message}</div> }
                        <div className={classes.content}>
                            <h3>Reset Your Password</h3>
                            <p className='text-muted'>Password must be at least 8 characters, at least one letter and one number</p>
                        </div>
                        <div className={classes.form}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-group mb-3">
                                    <label>New password</label>
                                    <input {...register('password', {required: true})} type="password" className="form-control" placeholder="Enter email" />
                                    {errors.password && <p className={classes.error_msg}>This field cannot be empty</p>}
                                </div>
                                <div className="form-group mb-3">
                                    <label>Confirm password</label>
                                    <input {...register('confirm_password', {required: true})} type="password" className="form-control" placeholder="Enter email" />
                                    {errors.confirm_password && <p className={classes.error_msg}>This field cannot be empty</p>}
                                </div>
                                <div className={classes.btn}>
                                    <button className="btn btn-large btn-primary" type="submit">Change password</button>
                                    <Link to="/login">&lt; Back to login</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChangePassword